import React from 'react';

const Footer = () => null;

export default Footer;
